import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { CbridgePalette } from '@cbridge-utils/mui-theme';

export const StyledPaneviewContainer = styled(Stack)({
  overflow: 'hidden',

  '& .dockview-theme-dark': {
    '--dv-group-view-background-color': 'transparent',
    '--dv-paneview-active-outline-color': 'transparent',
    '--dv-paneview-header-border-color': 'transparent',
    '--dv-separator-border': CbridgePalette.divider,
    '--dv-sash-color': 'transparent',
    '--dv-active-sash-color': CbridgePalette.border,
    '--dv-active-sash-transition-delay': '0s',
    background: 'transparent',
  },

  '& .dv-pane-header': {
    display: 'none',
  },

  '& .dv-pane-body': {
    overflow: 'hidden !important',
  },

  '& .dv-pane .dv-pane-body:focus::before, & .dv-pane .dv-pane-body:focus-within::before': {
    display: 'none',
  },

  '& .dv-pane-container .dv-view:not(:first-child)::before': {
    backgroundColor: `${CbridgePalette.divider} !important`,
  },

  '& .dv-view:has(.paneview-spacer)::before': {
    display: 'none !important',
  },

  '& .sash-hidden': {
    pointerEvents: 'none !important',
    cursor: 'default !important',
    visibility: 'hidden !important',
  },
});
